module.exports = __webpack_public_path__ + "img/transfer.8d7bee0d.svg";